$(document).ready(function(){
$('.slick-track-testi').slick({
  dots:true,
  infinite: true,
  autoplay: true,
  speed: 350,
  slidesToShow:2,
  slidesToScroll:2,
  responsive: [
    {
      breakpoint:1000,
      settings: {
        slidesToShow:1,
        slidesToScroll:1,
        infinite: true,
        dots:true
      }
    },
	{
      breakpoint:600,
      settings: {
        slidesToShow:1,
        slidesToScroll:1,
        infinite: true,
        dots:true
      }
    }
  ]
});
});